import { useState } from 'react';
import { Form } from 'react-bootstrap';
import profileImg from '../../../assets/images/articalsdetails-profile.png';
import './Comments.css';

const CommentItem = ({ comment, depth = 0 }) => {
  const [showReplyInput, setShowReplyInput] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [replies, setReplies] = useState(comment.replies || []);
  const [likes, setLikes] = useState(comment.likes || 0);

  const handleReplySubmit = () => {
    if (!replyText.trim()) return;
    const newReply = {
      id: Date.now(),
      author: 'You',
      avatar: profileImg,
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      text: replyText.trim(),
      likes: 0,
      replies: [],
    };
    setReplies((prev) => [...prev, newReply]);
    setReplyText('');
    setShowReplyInput(false);
  };

  return (
    <div className={`cs-comment ${depth > 0 ? 'cs-comment--reply' : ''}`}>
      <img src={comment.avatar} alt={comment.author} className="cs-comment__avatar" />
      <div className="cs-comment__body">
        <div className="cs-comment__header">
          <span className="cs-comment__author">{comment.author}</span>
          <span className="cs-comment__date">{comment.date}</span>
        </div>
        <p className="cs-comment__text">{comment.text}</p>
        <div className="cs-comment__actions">
          <button
            className="cs-comment__action-btn cs-comment__action-btn--reply"
            onClick={() => setShowReplyInput((v) => !v)}
          >
            Reply
          </button>
          <button
            className="cs-comment__action-btn cs-comment__action-btn--count"
            onClick={() => setLikes((l) => l + 1)}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
              <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
            </svg>
            {likes}
          </button>
          <button className="cs-comment__action-btn cs-comment__action-btn--count">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            {replies.length}
          </button>
        </div>

        {showReplyInput && (
          <div className="cs-comment__reply-input-wrap">
            <div className="cs-comment-form__input-wrap">
              <Form.Control
                type="text"
                placeholder="Write a reply..."
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleReplySubmit()}
                className="cs-comment-form__input"
              />
              <button className="cs-comment-form__send" onClick={handleReplySubmit} aria-label="Send reply">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {replies.length > 0 && (
          <div className="cs-comment__replies">
            {replies.map((reply) => (
              <CommentItem key={reply.id} comment={reply} depth={depth + 1} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const Comments = ({ comments = [], authorAvatar }) => {
  const [newComment, setNewComment] = useState('');
  const [commentList, setCommentList] = useState(comments);

  const handleSubmit = () => {
    if (!newComment.trim()) return;
    const entry = {
      id: Date.now(),
      author: 'You',
      avatar: authorAvatar || profileImg,
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      text: newComment.trim(),
      likes: 0,
      replies: [],
    };
    setCommentList((prev) => [entry, ...prev]);
    setNewComment('');
  };

  return (
    <div className="cs-comments">
      <h3 className="cs-comments__heading">Add Comments</h3>

      <div className="cs-comment-form">
        <div className="cs-comment-form__avatar-ring">
          <img src={authorAvatar || profileImg} alt="you" className="cs-comment-form__avatar" />
        </div>
        <div className="cs-comment-form__input-wrap">
          <Form.Control
            type="text"
            placeholder="Ask a question..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            className="cs-comment-form__input"
          />
          <button className="cs-comment-form__send" onClick={handleSubmit} aria-label="Send comment">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </button>
        </div>
      </div>

      <div className="cs-comments-list">
        {commentList.map((c) => (
          <CommentItem key={c.id} comment={c} />
        ))}
      </div>
    </div>
  );
};
